export { default as CommonForm } from "./common-form.component";
export { default as ICarrosForm } from "./icarros-form.component";
export { default as MobiautoForm } from "./mobiauto-form.component";
export { default as WebmotorsForm } from "./webmotors-form.component";
export { default as UsadosbrForm } from "./usadosbr-form.component";
export { default as PortalIntegration } from "./portals-integration.component";